import { FC, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { cloneDeep } from 'lodash'

import { Button } from 'components/Forms'
import BaseModal from './BaseModal'
import { closeModal } from 'store/actions/modals'
import useUpdateSettings from '../UI/Filter/hooks/useUpdateSettings'
import { MFilters } from 'types/filterTypes'

import { t } from 'translations'

type DeleteSearchPresetConfirmationModalProps = {
  contentName: MFilters.ContentTypes
  presetName: string
  selectedPreset: string
}

const DeleteSearchPresetConfirmationModal: FC<DeleteSearchPresetConfirmationModalProps> = ({ contentName, presetName, selectedPreset }) => {
  const dispatch = useDispatch()
  const presetKey: MFilters.PresetKey = `saved-search-${contentName}`
  const filterKey: MFilters.FilterKey = `filter-${contentName}`
  const settings = useSelector((state: MStore.RootState) => state.settings)

  const presets: MFilters.PresetTypes<typeof filterKey> = useMemo(() => {
    return settings[presetKey] || {}
  }, [settings, presetKey])

  const { savePresets, saveOptions } = useUpdateSettings(contentName)

  const remove = (presetName: string) => {
    const updatedPresets = cloneDeep(presets)
    delete updatedPresets[presetName]
    savePresets(updatedPresets)
    if (presetName === selectedPreset) saveOptions({ rangeStart: '', rangeEnd: '' })
    dispatch(closeModal())
  }
  return (
    <BaseModal title="searchBar.DELETE_PRESET_CONFIRMATION_MODAL" summaryVar={{ presetName }} hideButtons>
      <div className="mt-3">
        <Button className="btn btn-danger mr-2" type="submit" text={`actions.DELETE`} onClick={() => remove(presetName)} />
        <Button className="btn btn-outline-secondary" onClick={() => dispatch(closeModal())}>
          {t(`actions.CANCEL`)}
        </Button>
      </div>
    </BaseModal>
  )
}

export default DeleteSearchPresetConfirmationModal
